import React from 'react'
import { Link } from 'react-router-dom'
import { ReadRegistrationDto } from 'api-client'
import { getFormattedDateTime } from 'shared/dates/formatters'

export const todayAppointmentsColumns = [
  {
    title: 'Full Name',
    render: (item: ReadRegistrationDto) => (
      item?.id ? (<Link to={`registrations/edit/${item?.id}`}>
          <span style={{ fontSize: 18 }}>
            <span style={{ marginRight: 10 }}>{item?.firstName}</span>
            <span>{item?.lastName}</span>
          </span>
      </Link>) : (<span style={{ fontSize: 18 }}>
            <span style={{ marginRight: 10 }}>{item?.firstName}</span>
            <span>{item?.lastName}</span>
          </span>)
    ),
  },
  {
    title: 'Time',
    render: (item: ReadRegistrationDto) => (
      <div>{item?.appointmentTime && getFormattedDateTime(item?.appointmentTime)}</div>
    ),
  },
]
